/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetPatientEditRequestResponse } from '../models/GetPatientEditRequestResponse';
import type { GetSubmittedPatientEditRequestsResponse } from '../models/GetSubmittedPatientEditRequestsResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PatientEditRequestService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetSubmittedPatientEditRequestsResponse
     * @throws ApiError
     */
    public patientEditRequestGetSubmittedPatientEditRequests(): Observable<Array<GetSubmittedPatientEditRequestsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patient-edit-requests',
        });
    }
    /**
     * @returns number
     * @throws ApiError
     */
    public patientEditRequestGetSubmittedCount(): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patient-edit-requests/submitted-count',
        });
    }
    /**
     * @param patientId
     * @returns GetPatientEditRequestResponse
     * @throws ApiError
     */
    public patientEditRequestGetPatientEditRequest(
        patientId: number,
    ): Observable<GetPatientEditRequestResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patient-edit-requests/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns number
     * @throws ApiError
     */
    public patientEditRequestRemovePatientEditStatus(
        patientId: number,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/v2/patient-edit-requests/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
}
